import { render, staticRenderFns } from "./ScreeningReportModal.vue?vue&type=template&id=371d1890"
import script from "./ScreeningReportModal.vue?vue&type=script&lang=js"
export * from "./ScreeningReportModal.vue?vue&type=script&lang=js"
import style0 from "./ScreeningReportModal.vue?vue&type=style&index=0&id=371d1890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports